import userSaga, { fetchUser, updateCompany } from '~/sagas/user/user.saga';

export default userSaga;

export { fetchUser, updateCompany };
